import { Typography } from "@mui/material"
import React, { useContext } from "react"
import { ProjectContext } from "../../../../../../core/context/project/ProjectContext"
import { customPalette } from "../../../../../../../theme"
import { formatToFrench } from "../../../../../../core/services/date-service"

interface IProps {
  title: string
}

export function ControlPanelTabHeader({ title }: Readonly<IProps>): React.JSX.Element {
  const { project } = useContext(ProjectContext)

  return (
    <>
      <Typography variant="h5" fontWeight={600} sx={{ mt: 2 }}>
        {title}
      </Typography>
      <Typography fontSize={10} fontWeight={400} sx={{ color: customPalette.lightGray4, mb: 1 }}>
        {` Mise à jour le ${formatToFrench(project?.lastModifiedDate)}`}
      </Typography>
    </>
  )
}
